import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'app-less-than-tooltip',
    templateUrl: './less-than-tooltip.component.html',
    styleUrls: ['./less-than-tooltip.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LessThanTooltipComponent implements OnInit {
   @Input() tooltipContent!: number;
   @Input() tooltipPosition: string = 'top';
   @Input() amount!: number;

   @Input() currency!: string;
   @Input() type: 'amount' | 'percentage' | 'number' = 'amount';
   @Input() amountStyle: { [key: string]: string } = {
      color: 'black',
      fontWeight: '400',
   };
   isNegative = false;

   constructor() {}

   ngOnInit(): void {
      this.isNegative = (this.amount ?? 0) < 0;
      this.tooltipContent = this.tooltipContent ?? this.amount;
   }

   get absAmount(): number {
      return Math.abs(this.amount ?? 0);
   }
}
